// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'dataviz-pivot-table';

export const Component = () => (
  <path d='M0 2v21h24V2H0Zm23 5H12.5V5H23v2ZM11.5 17H4v-5h16v5h-8.5Zm9.5 1V9h-8.5V8H23v11H12.5v-1H21ZM1 5h10.5v2H1V5Zm0 3h10.5v1H3v9h8.5v1H1V8Zm0 12h10.5v2H1v-2Zm11.5 2v-2H23v2H12.5Z' />
);

export const viewBox = '0 0 25 25';
